// extracted by mini-css-extract-plugin
module.exports = {"pipFarmContainer":"LandingPagePipFarm_pipFarmContainer__5uaze","pipFarmContainer__wrapper":"LandingPagePipFarm_pipFarmContainer__wrapper__1X1KE"};